import Http from '../network/Http'
import {ContentType} from '../network/Constants'

export class PersonalInfoExtractHistoryRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async registerPersonalInfoExtractHistory(
        operationCategory: string,
        count: number,
        formName: string,
    ): Promise<void> {
        await this.http.post(
            '/api/admin/registerPersonalInfoExtractHistory',
            {
                operationCategory: operationCategory,
                count: count,
                formName: formName,
            },
            ContentType.JSON,
        )
    }
}
